<p class="text-center" style="margin-top: 60px;">
  <a href="http://ifi.kapkerkoz.hu" class="btn btn-outline-success">Bővebben ezen a honlapon tájékozódhat ifjúsági szolgálatunkról.</a>
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/youth/youth.component.html